// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.download-dropdown-menu {
    min-width: 200px;
}

.download-checkbox-item {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 0.25rem 1rem;
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
}

.download-checkbox-item:hover {
    background-color: #f8f9fa;
}

.download-checkbox-item input[type="checkbox"] {
    cursor: pointer;
}

.download-button-container {
    padding: 0.5rem 1rem;
}

.download-selected-button {
    width: 100%;
    padding: 0.4rem 0.5rem;
    font-size: 0.9rem;
    font-weight: bold;
    text-align: center;
    border: none;
    border-radius: 0.25rem;
    transition: all 0.2s ease;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.download-selected-button.enabled {
    background-color: #17a2b8;
    color: white;
    cursor: pointer;
}

.download-selected-button.enabled:hover {
    background-color: #138496;
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(0,0,0,0.2);
}

.download-selected-button.disabled {
    background-color: #e9ecef;
    color: #6c757d;
    cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/Magor/Components/css/DownloadButton.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,qBAAqB;IACrB,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,sBAAsB;IACtB,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,qCAAqC;AACzC;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,mBAAmB;AACvB","sourcesContent":[".download-dropdown-menu {\n    min-width: 200px;\n}\n\n.download-checkbox-item {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 0.25rem 1rem;\n    cursor: pointer;\n    user-select: none;\n}\n\n.download-checkbox-item:hover {\n    background-color: #f8f9fa;\n}\n\n.download-checkbox-item input[type=\"checkbox\"] {\n    cursor: pointer;\n}\n\n.download-button-container {\n    padding: 0.5rem 1rem;\n}\n\n.download-selected-button {\n    width: 100%;\n    padding: 0.4rem 0.5rem;\n    font-size: 0.9rem;\n    font-weight: bold;\n    text-align: center;\n    border: none;\n    border-radius: 0.25rem;\n    transition: all 0.2s ease;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.download-selected-button.enabled {\n    background-color: #17a2b8;\n    color: white;\n    cursor: pointer;\n}\n\n.download-selected-button.enabled:hover {\n    background-color: #138496;\n    transform: translateY(-1px);\n    box-shadow: 0 2px 4px rgba(0,0,0,0.2);\n}\n\n.download-selected-button.disabled {\n    background-color: #e9ecef;\n    color: #6c757d;\n    cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
